<app-section #parentSection
             class="offer-modifications offer-modifications--additional-options"
             *ngIf="sectionVisible"
             [title]="title"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [formConfig]="formConfig">

    <ng-template #section>

        <div class="offer-modifications__content">
            <div *ngFor="let mod of visibleModifications"
                 [class]="'offer-modifications__modification offer-modifications__modification__BEESAFE--' + mod.code">
                <app-radio-tile [bean]="bean"
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[mod.code]"
                                [fieldConfig]="formFactoryService.fieldConfig(mod.code, formConfig)"
                                (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
                </app-radio-tile>

                <a *ngIf="mod.code === 'ASSISTANCE' || mod.code === 'NNW'" class="offer-modifications__link-btn offer-modifications__compare-btn"
                   (click)="compareCoverages(mod.code)">
                    {{ (mod.code === 'ASSISTANCE' ? 'BEESAFE_OFFER_MODIFICATIONS.compareCoveragesAssistance' : 'BEESAFE_OFFER_MODIFICATIONS.compareCoveragesNNW') | translate }}
                </a>
            </div>

            <a *ngIf="expandModificationsButtonVisible" class="offer-modifications__link-btn" (click)="toggleVisibility()">
                <span *ngIf="!allModificationsVisible">{{ 'OFFER_MODIFICATIONS.expand' | translate }}</span>
                <span *ngIf="allModificationsVisible">{{ 'OFFER_MODIFICATIONS.collapse' | translate }}</span>
            </a>

            <div *ngIf="allModificationsVisible">
                <div *ngFor="let mod of invisibleModifications" class="offer-modifications__modification">
                    <app-radio-tile [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[mod.code]"
                                    [fieldConfig]="formFactoryService.fieldConfig(mod.code, formConfig)"
                                    (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
                    </app-radio-tile>
                </div>
            </div>
        </div>

    </ng-template>
</app-section>

<app-driver-sos-details-banner *ngIf="bannerVisible"></app-driver-sos-details-banner>
